import React, { useState } from 'react';
import SOPDashboard from './SOPDashboard';
import ScenarioPlanning from './ScenarioPlanning';
import InsightsDashboard from './InsightsDashboard';
import { useAuth } from '../../contexts/AuthContext';
import './SOPPlanning.css';

type SOPView = 'dashboard' | 'scenarios' | 'insights';

const SOPPlanning: React.FC = () => {
  const [activeView, setActiveView] = useState<SOPView>('dashboard');
  const { state: authState } = useAuth();

  // Make S&OP data available globally for AI Assistant context
  React.useEffect(() => {
    const sopData = {
      active_view: activeView,
      tenant_id: authState.user?.tenant_id,
      tenant_name: authState.user?.tenant?.name,
      planning_data: {
        current_week: new Date().toISOString().slice(0, 10),
        horizon: '52 weeks',
        scenarios: [], // This would be populated from actual S&OP data
      },
      // Additional context data would be populated by child components
      dashboard_data: (window as any).sopDashboardData || null,
      scenario_data: (window as any).sopScenarioData || null,
      insights_data: (window as any).sopInsightsData || null
    };
    (window as any).warehouseSOPData = sopData;
  }, [activeView, authState.user]);

  const renderContent = () => {
    switch (activeView) {
      case 'scenarios':
        return <ScenarioPlanning />;
      case 'insights':
        return <InsightsDashboard />;
      default:
        return <SOPDashboard />;
    }
  };

  // Show loading or error if not authenticated
  if (!authState.isAuthenticated || !authState.user) {
    return (
      <div className="sop-planning">
        <div className="sop-error">
          <p>Authentication required to access S&OP Planning.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sop-planning">
      <div className="sop-header">
        <h2>S&OP Planning - {authState.user.tenant?.name || 'Your Organization'}</h2>
      </div>
      
      <div className="sop-nav">
        <button 
          className={`sop-nav-button ${activeView === 'dashboard' ? 'active' : ''}`}
          onClick={() => setActiveView('dashboard')}
        >
          Planning Dashboard
        </button>
        <button 
          className={`sop-nav-button ${activeView === 'scenarios' ? 'active' : ''}`}
          onClick={() => setActiveView('scenarios')}
        >
          Scenario Planning
        </button>
        <button 
          className={`sop-nav-button ${activeView === 'insights' ? 'active' : ''}`}
          onClick={() => setActiveView('insights')}
        >
          AI Insights
        </button>
      </div>

      <div className="sop-content">
        <div className="sop-main-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default SOPPlanning;